import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Icona Material Symbols Rounded (STILE-VISUALE.md §2.3). Decorativa: aria-hidden, il significato va dato
 * dal testo accanto o dall'aria-label del controllo che la contiene.
 * `name` è il nome del glifo (es. 'assignment'); `filled` solo per avatar/persona e logo.
 */
@Component({
    selector: 'app-icon',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'material-symbols-rounded',
        '[class.is-filled]': 'filled()',
        '[style.font-size.px]': 'size()',
        'aria-hidden': 'true',
    },
    template: `{{ name() }}`,
})
export class IconComponent {
    name   = input.required<string>();
    filled = input(false);
    size   = input<number>();
}
